// Supermove
import {gql} from '@supermove/graphql';
import {JobModel} from '@supermove/models';
import {withFragment} from '@supermove/utils';

// App
import DisplayValuesForm from '@shared/modules/Billing/forms/DisplayValuesForm';
import UpdateValuesForm from '@shared/modules/Billing/forms/UpdateValuesForm';
import ValueForm, {ValueFormAsForm} from '@shared/modules/Billing/forms/ValueForm';

export interface JobEstimateHoursFormFields {
  jobId: string;
  minEstimateHoursValueForm: ValueFormAsForm;
  maxEstimateHoursValueForm: ValueFormAsForm;
}

const edit = withFragment(
  (job: JobModel) => {
    const valueForms = DisplayValuesForm.edit([
      job.minEstimateHoursValue,
      job.maxEstimateHoursValue,
    ]);
    return {
      jobId: job.id,
      minEstimateHoursValueForm: ValueForm.toForm(valueForms.valueForms[0]),
      maxEstimateHoursValueForm: ValueForm.toForm(valueForms.valueForms[1]),
    };
  },
  gql`
    ${UpdateValuesForm.edit.fragment}
    ${DisplayValuesForm.edit.fragment}

    fragment JobEstimateHoursForm_edit on Job {
      id
      minEstimateHoursValue {
        id
        amount
        ...DisplayValuesForm_edit
      }
      maxEstimateHoursValue {
        id
        amount
        ...DisplayValuesForm_edit
      }
      project {
        id
        ...UpdateValuesForm_edit
      }
    }
  `,
);

const toMutation = ({
  jobId,
  minEstimateHoursValueForm,
  maxEstimateHoursValueForm,
}: JobEstimateHoursFormFields) => ({
  jobId,
  minEstimateHoursValueForm: ValueForm.toMutation(minEstimateHoursValueForm),
  maxEstimateHoursValueForm: ValueForm.toMutation(maxEstimateHoursValueForm),
});

const JobEstimateHoursForm = {
  edit,
  toMutation,
};

export default JobEstimateHoursForm;
